import styled from 'styled-components';
import { Form } from '@bynder/design-system';

export const CustomFormLabel = styled(Form.Label)`
    display: flex;
    & > :first-child {
        flex: 1;
    }
`;
